import {MenuOption} from "../../../../gd-components/popover-menu/popover-menu/const";
import {TaskAction} from "../@const";
import Task from "../../../../model2/task/task";


export type Props = {
    task                : Task

    hiddenActions?      : TaskAction[],
    disabledActions?    : string[]
}

export function taskMore_initCreateReminder(props: Props, menuOptions:MenuOption[]) {

    const task = props.task

    if (props.hiddenActions?.includes(TaskAction.CREATE_REMINDER)) return

    const onClick = () => {
        gd.modals.task.createReminder(props.task, gd.user.id)
    }

    menuOptions.push({
        icon        : "i5-notification",
        label       : "Create Reminder",
        onClick     : onClick,
        disabled    : !props.task.acl.canAddReminder,
    })



}
